// Modules
import store from 'app-store';

import { UPDATE, UPDATE_ONE } from './action-types';


export function update(key, data) {
  store.dispatch({
    type: UPDATE,
    key,
    data
  });
}

export function updateOne(key, updatedItem, sortBy) {
  store.dispatch({
    type: UPDATE_ONE,
    key,
    updatedItem,
    sortBy
  });
}



// WEBPACK FOOTER //
// ./app/modules/page-data/actions.js